import { useAtom } from "jotai";

import { accessTokenAtom } from "../atoms/auth-atom";

export const useAccessToken = () => {
  const [accessToken, setAccessToken] = useAtom(accessTokenAtom);

  return [accessToken, setAccessToken] as const;
};
